import type { ReactNode } from "react";
import { Icon } from "./Icon.js";

/**
 * The top of every signed-in screen: where you are, how to get back, and the
 * actions that belong to the whole screen. One component so the title, the
 * back link and the buttons sit in the same place everywhere.
 */
export function PageHeader({
  title,
  back,
  meta,
  actions,
}: {
  title: ReactNode;
  back?: { label: string; onClick: () => void } | undefined;
  meta?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header className="page-head">
      {back && (
        <button type="button" className="back-link" onClick={back.onClick}>
          <Icon name="chevron-left" size={16} />
          {back.label}
        </button>
      )}
      <div className="page-head-row">
        <div className="page-head-text">
          <h1 className="page-title">{title}</h1>
          {meta && <div className="page-meta">{meta}</div>}
        </div>
        {actions && <div className="page-actions">{actions}</div>}
      </div>
    </header>
  );
}
